(() => {
  function getUrlParams() {
    const params = new URLSearchParams(window.location.search);
    return {
      min: parseInt(params.get('discount_min'), 10) || 0,
      max: parseInt(params.get('discount_max'), 10) || 100
    };
  }

  function syncUrl(min, max) {
    const url = new URL(window.location.href);
    if (min > 0) url.searchParams.set('discount_min', min);
    else url.searchParams.delete('discount_min');

    if (max < 100) url.searchParams.set('discount_max', max);
    else url.searchParams.delete('discount_max');

    window.history.replaceState({}, '', url.toString());
  }

  function syncInputs(min, max) {
    document.querySelectorAll('.js-discount-min').forEach(el => el.value = min === 0 ? '' : min);
    document.querySelectorAll('.js-discount-max').forEach(el => el.value = max === 100 ? '' : max);
  }

  function applyDiscountFilter() {
    const { min, max } = getUrlParams();
    const items = document.querySelectorAll('.js-discount-item');
    let visibleCount = 0;

    items.forEach(item => {
      const itemDiscount = parseInt(item.getAttribute('data-discount'), 10) || 0;
      
      if (itemDiscount >= min && itemDiscount <= max) {
        item.removeAttribute('data-discount-hidden');
        visibleCount++;
      } else {
        item.setAttribute('data-discount-hidden', 'true');
      }
    });

    // Show empty state if nothing matches
    const grid = document.getElementById('product-grid');
    if (grid) {
      let emptyMsg = grid.querySelector('.discount-no-results-msg');
      if (items.length > 0 && visibleCount === 0) {
        if (!emptyMsg) {
          emptyMsg = document.createElement('div');
          emptyMsg.className = 'discount-no-results-msg';
          emptyMsg.textContent = 'No products match this discount range.';
          grid.appendChild(emptyMsg);
        }
      } else if (emptyMsg) {
        emptyMsg.remove();
      }
    }
  }

  function onInputChange(e) {
    e.stopPropagation(); // Stop native theme from reloading the page
    
    const activeContainer = e.target.closest('.discount-range-container');
    const minInput = activeContainer.querySelector('.js-discount-min').value;
    const maxInput = activeContainer.querySelector('.js-discount-max').value;

    let min = parseInt(minInput, 10);
    let max = parseInt(maxInput, 10);

    if (isNaN(min) || min < 0) min = 0;
    if (isNaN(max) || max > 100) max = 100;
    
    // Auto-swap if user types 80 in min and 20 in max
    if (min > max) { 
      let temp = min; 
      min = max; 
      max = temp; 
    }

    syncUrl(min, max);
    syncInputs(min, max);
    applyDiscountFilter();
  }

  function init() {
    const { min, max } = getUrlParams();
    syncInputs(min, max);
    applyDiscountFilter();

    // Trigger filter when user types and clicks out / hits Enter
    document.addEventListener('change', (e) => {
      if (e.target.classList.contains('js-discount-min') || e.target.classList.contains('js-discount-max')) {
        onInputChange(e);
      }
    });

    // Re-apply if "Load More" adds new products
    const container = document.getElementById('ProductGridContainer') || document.body;
    const observer = new MutationObserver(mutations => {
      for (const mutation of mutations) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          applyDiscountFilter();
          break;
        }
      }
    });
    observer.observe(container, { childList: true, subtree: true });

    // Handle back button
    window.addEventListener('popstate', () => {
      const params = getUrlParams();
      syncInputs(params.min, params.max);
      applyDiscountFilter();
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();